import { repositoryCache } from './repositoryCache';
import { getRepositories } from './repositoryRegistry';
export async function resolveRepository(domain) {
    const cached = repositoryCache.get(domain);
    if (cached)
        return cached;
    const repos = getRepositories();
    const match = repos.find((repository) => repository.capabilities?.[domain]);
    if (!match?.capabilities?.[domain]) {
        throw new Error(`No repository found for domain: ${domain}`);
    }
    const promise = match.capabilities[domain]();
    repositoryCache.set(domain, promise);
    return promise;
}
